import type { ChatFilter } from "./types"
import { useTranslation } from "@/clientWeb/i18n/LanguageContext"

const FILTER_KEYS: { value: ChatFilter; labelKey: string }[] = [
  { value: "all",       labelKey: "common.all" },
  { value: "unread",    labelKey: "presence.unread" },
  { value: "groups",    labelKey: "presence.groups" },
  { value: "favorites", labelKey: "presence.favorites" },
  { value: "pinned",    labelKey: "presence.pinned" },
]

interface ChatFilterChipsProps {
  current: ChatFilter
  onChange: (filter: ChatFilter) => void
}

export function ChatFilterChips({ current, onChange }: ChatFilterChipsProps) {
  const t = useTranslation()
  return (
    <div className="flex items-center gap-2 px-3 py-2 overflow-x-auto scrollbar-hide shrink-0">
      {FILTER_KEYS.map(({ value, labelKey }) => {
        const label = t(labelKey)
        const isActive = current === value
        return (
          <button
            key={value}
            onClick={() => onChange(value)}
            className={`flex-shrink-0 px-3 py-1 text-xs font-semibold rounded-full border transition-all
              ${isActive
                ? "bg-primary/10 border-primary text-primary"
                : "bg-muted/50 border-transparent text-muted-foreground hover:text-foreground hover:bg-muted"}`}
          >
            {label}
          </button>
        )
      })}
    </div>
  )
}
